function toNumberString(v) {
  if (v < 10) {
    return "0" + v;
  } else {
    return "" + v;
  }
}

export default {
  today() {
    let now = new Date();

    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    now.setMilliseconds(0);

    return now;
  },

  toDateString(t) {
    return [t.getFullYear(), t.getMonth() + 1, t.getDate()].map(toNumberString).join("-")
  },

  toTimeString(t) {
    return [t.getHours(), t.getMinutes(), t.getSeconds()].map(toNumberString).join(":")
  },

  toDateTimeString(t) {
    return this.toDateString(t) + " " + this.toTimeString(t)
  },
  dateStrForma(str, from, to){
    //'20190626' 'YYYYMMDD' 'YYYY年MM月DD日'
    str += ''
    let Y = ''
    if(~(Y = from.indexOf('YYYY'))){
      Y = str.substr(Y, 4)
      to = to.replace(/YYYY|yyyy/g,Y)
    }else if(~(Y = from.indexOf('YY'))){
      Y = str.substr(Y, 2)
      to = to.replace(/YY|yy/g,Y)
    }
    let k,i
    ['M','D','H','h','m','s'].forEach(s =>{
      i = from.indexOf(s+s)
      k = ~i ? str.substr(i, 2) : ''
      to = to.replace(s+s, k)
    })
    return to
  }
  //   // console.log(dateLib.dateStrForma('2020-03-18 20:56:52','YYYY-MM-DD HH:mm:ss','YYYY年MM月DD日 HH:mm'))
// dateStrForma('20190626', 'YYYYMMDD', 'YYYY年MM月DD日') ==> 2019年06月26日
// dateStrForma('121220190626', '----YYYYMMDD', 'YYYY年MM月DD日') ==> 2019年06月26日
// dateStrForma('2019年06月26日', 'YYYY年MM月DD日', 'YYYYMMDD') ==> 20190626

}
